import { render, staticRenderFns } from "./addChargeItem.vue?vue&type=template&id=db54f69e&"
import script from "./addChargeItem.vue?vue&type=script&lang=js&"
export * from "./addChargeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db54f69e')) {
      api.createRecord('db54f69e', component.options)
    } else {
      api.reload('db54f69e', component.options)
    }
    module.hot.accept("./addChargeItem.vue?vue&type=template&id=db54f69e&", function () {
      api.rerender('db54f69e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/communityPartyBuilding/swimming/addChargeItem.vue"
export default component.exports